export default __webpack_public_path__ + "src/assets/privacy.509aeba8b36c4ed5722e1309d05b3de2.svg";